<template>
  <div>
    <multi-select
      v-if="showAdd"
      v-model="contactSelectedToAdd"
      :options="options"
      :searchable="true"
      :loading="isLoading"
      :internal-search="false"
      :hide-selected="true"
      track-by="last_name"
      label="last_name"
      :taggable="true"
      placeholder="Введите имя для поиска или создания"
      tag-placeholder="Enter чтобы создать"
      select-label="Enter чтобы выбрать"
      @input="onSelect"
      @tag="addNewUser"
      @search-change="asyncFind"
    >
      <template slot="noOptions">Начните вводить имя</template>
      <template slot="singleLabel" slot-scope="{ option }"> {{ fullContact(option) }}</template>
      <template slot="option" slot-scope="props">{{ fullContact(props.option) }}{{ props.option.label }}</template>
      <span slot="noResult">Не найдено</span>
    </multi-select>

    <div v-for="contact in contacts" v-bind:key="contact.id" class="px-1">
      <contact-list-entry
        :contact="contact"
        v-on:removeItem="removeContact"
      />
    </div>


    <b-button size="sm" class="my-2" @click="showAdd=true">
      <b-icon-person-plus />
      Добавить
    </b-button>

    <b-modal
      id="modal-user-add"
      size="lg"
      title="Новый контакт"
      hide-footer
    >
      <b-form
        @submit="createContact"
        size="sm"
      >
        <b-form-group
          label="Фамилия:"
          label-cols-sm="4"
          label-cols-lg="4"
          aria-required="true"
        >
          <b-form-input
            type="text"
            v-model="form.last_name"
          />
        </b-form-group>
        <b-form-group
          label="Имя:"
          label-cols-sm="4"
          label-cols-lg="4"
        >
          <b-form-input
            type="text"
            v-model="form.first_name"
          />
        </b-form-group>
        <b-form-group
          label="Отчество:"
          label-cols-sm="4"
          label-cols-lg="4"
        >
          <b-form-input
            type="text"
            v-model="form.middle_name"
          />
        </b-form-group>
        <b-form-group
          label="Телефон:"
          label-cols-sm="4"
          label-cols-lg="4"
        >
          <b-form-input
            v-model="form.phone"
            type="text"
          />
        </b-form-group>
        <b-form-group
          label="E-mail:"
          label-cols-sm="4"
          label-cols-lg="4"
        >
          <b-form-input
            v-model="form.email"
            type="email"
          />
        </b-form-group>
        <b-form-group
          label="Дата рождения:"
          label-cols-sm="4"
          label-cols-lg="4"
        >
          <date-picker
            v-model="form.birth_date"
            placeholder="Выберите дату"
            :lang="datepicker.lang"
            :format="datepicker.format"
            :value-type="datepicker.valueType"
          />
        </b-form-group>
        <b-alert
          v-model="error"
          dismissible
          variant="danger"
        >
          {{message}}
        </b-alert>
        <loading-button
          :is-busy="isBusyCreate"
          text="Создать"
        />
      </b-form>
    </b-modal>
  </div>
</template>

<script>
  import ContactListEntry from "./ContactListEntry";
  import MultiSelect from 'vue-multiselect'
  import commonMixin from '../mixins/common';
  import LoadingButton from "../components/LoadingButton";
  import datapickerMixin from '../mixins/datapicker';

  export default {
    name: "contacts",
    mixins: [commonMixin, datapickerMixin],
    components: {ContactListEntry, MultiSelect, LoadingButton},
    props: {
      value: Array
    },
    data() {
      return {
        contactSelectedToAdd: [],
        options: [],
        isLoading: false,
        contacts: [],
        showAdd: false,
        form: {
          first_name: '',
          last_name: '',
          middle_name: '',
          phone: '',
          email: '',
          birth_date: ''
        },
        error: false,
        message: '',
        isBusyCreate: false,
      }
    },
    watch: {
      'value': {
        handler: function (data) {
          if (data) {
            this.contacts = data;
          }
        },
        immediate: true,
        deep: true
      }
    },
    methods: {
      removeContact(contactId) {
        this.contacts = this.contacts.filter(function (value) {
          return value.id !== contactId;
        });
        this.$emit('input', this.contacts);
      },
      asyncFind(query) {
        this.isLoading = true
        const promise = this.axios.get(process.env.VUE_APP_BACKEND_URL + '/api/contacts/?query=' + query);
        return promise.then(response => {
          this.options = response.data.contacts;
          this.contacts.forEach(e => {
            this.options = this.options.filter(function (value) {
              return value.id !== e.id
            });
          });

          this.isLoading = false;
        }).catch((error) => {
          console.log(error);
          this.options = [];
          this.isLoading = false;
        });
      },
      onSelect(evt) {
        this.contacts = this.contacts.filter(function (value) {
          return value.id !== evt.id;
        });
        this.contacts.push(evt)
        this.$emit('input', this.contacts);
        this.contactSelectedToAdd = [];
        this.showAdd = false;
      },
      addNewUser(newName) {
        const n = newName.split(' ')
        this.form.last_name = n[0] ? n[0] : ''
        this.form.first_name = n[1] ? n[1] : ''
        this.form.middle_name = n[2] ? n[2] : ''
        this.$bvModal.show('modal-user-add')
      },
      createContact(evt) {
        evt.preventDefault();
        this.error = false;
        this.isBusyCreate = true;
        this.axios.put(process.env.VUE_APP_BACKEND_URL + '/api/contacts/', JSON.stringify(this.form)
        ).then((response) => {
          this.isBusyCreate = false;
          if (response) {
            if (response.data.error === false) {
              this.error = false;
              this.contacts.push(response.data.contact);
              this.$bvModal.hide('modal-user-add')
            } else {
              this.error = true;
              this.message = response.data.message;
            }
          }
        })
          .catch((error) => {
            console.log(error);
            this.isBusyCreate = false;
          })
      },
    }
  }
</script>
s
